/* eslint-disable react/prop-types */
import React from "react";
import Checkbox from "@visiblethread/react-components/dist/components/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { setDocCheckState } from "slices/dictionarySearch/dictionarySearchSlice";
import { checkedTypes } from "constants/types";
import PropTypes from "prop-types";
import { getImage } from "utils";
import { isEmptyDocument } from "utils/dictionarySearch";

const DocumentHeaderItem = ({ doc, handleCheck }) => (
  <div
    className={`documents__header__item${
      doc.checkState === checkedTypes.EMPTY || doc.occurrences === 0
        ? " greyed"
        : ""
    }`}
    data-testid="document-header-item"
  >
    <Checkbox
      state={doc.checkState}
      handleChange={() => handleCheck(doc)}
      disabled={isEmptyDocument(doc)}
      id="doc_header_cb"
      value="doc_header_cb"
    />
    <span title={doc.name}>{doc.name}</span>
    <img src={getImage(doc.name)} alt="doc-img" />
  </div>
);

const Header = ({ headerRef }) => {
  const dispatch = useDispatch();
  const documents = useSelector(
    (state) => state.dictionarySearch.folder.documents
  );
  const handleCheck = (doc) => {
    const newState =
      doc.checkState === undefined || doc.checkState === checkedTypes.EMPTY
        ? checkedTypes.CHECKED
        : checkedTypes.EMPTY;
    dispatch(setDocCheckState({ id: doc.id, checkState: newState }));
  };

  return (
    <div
      className="documents__header"
      ref={headerRef}
      data-testid="documents-header"
    >
      {documents?.map((d) => (
        <DocumentHeaderItem doc={d} handleCheck={handleCheck} />
      ))}
    </div>
  );
};

export default Header;

Header.propTypes = {
  headerRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // An object
    PropTypes.object,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};
